import { render, staticRenderFns } from "./no-background.vue?vue&type=template&id=52be4814&scoped=true&"
import script from "./no-background.vue?vue&type=script&lang=js&"
export * from "./no-background.vue?vue&type=script&lang=js&"
import style0 from "./no-background.vue?vue&type=style&index=0&id=52be4814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be4814",
  null
  
)

export default component.exports